import React from 'react';
import NewButton from '@/components/Form/Button';

// Adapter to route old props to new props
const Button: React.FC<any> = (props) => {
  const { raised, ...rest } = props;
  
  // Map 'raised' prop to variant if present, otherwise default logic
  const variant = props.icon && !props.label ? 'icon' : (raised ? 'primary' : 'text');
  
  return <NewButton variant={variant} {...rest} />;
};

export default Button;